"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AiIntegrationSlots () {
        return AiIntegrationSlots;
    },
    get IntegrationSlotTypes () {
        return IntegrationSlotTypes;
    },
    get IntegrationSlots () {
        return IntegrationSlots;
    },
    get STORE_DEFINITIONS () {
        return STORE_DEFINITIONS;
    }
});
const _nocodbsdk = require("nocodb-sdk");
var IntegrationSlots = /*#__PURE__*/ function(IntegrationSlots) {
    IntegrationSlots["SLOT0"] = "slot_0";
    IntegrationSlots["SLOT1"] = "slot_1";
    IntegrationSlots["SLOT2"] = "slot_2";
    IntegrationSlots["SLOT3"] = "slot_3";
    IntegrationSlots["SLOT4"] = "slot_4";
    IntegrationSlots["NUMERIC_SLOT0"] = "slot_5";
    IntegrationSlots["NUMERIC_SLOT1"] = "slot_6";
    IntegrationSlots["NUMERIC_SLOT2"] = "slot_7";
    IntegrationSlots["NUMERIC_SLOT3"] = "slot_8";
    IntegrationSlots["NUMERIC_SLOT4"] = "slot_9";
    return IntegrationSlots;
}({});
var IntegrationSlotTypes = /*#__PURE__*/ function(IntegrationSlotTypes) {
    IntegrationSlotTypes["NUMBER"] = "number";
    IntegrationSlotTypes["STRING"] = "string";
    IntegrationSlotTypes["BOOLEAN"] = "boolean";
    IntegrationSlotTypes["OBJECT"] = "object";
    IntegrationSlotTypes["ARRAY"] = "array";
    return IntegrationSlotTypes;
}({});
var AiIntegrationSlots = /*#__PURE__*/ function(AiIntegrationSlots) {
    AiIntegrationSlots["input_tokens"] = "input_tokens";
    AiIntegrationSlots["output_tokens"] = "output_tokens";
    AiIntegrationSlots["total_tokens"] = "total_tokens";
    AiIntegrationSlots["model"] = "model";
    return AiIntegrationSlots;
}({});
const STORE_DEFINITIONS = {
    [_nocodbsdk.IntegrationsType.Ai]: {
        ["input_tokens"]: {
            id: "slot_5",
            type: "number",
            required: false,
            description: 'Input tokens spent on operation'
        },
        ["output_tokens"]: {
            id: "slot_6",
            type: "number",
            required: false,
            description: 'Output tokens spent on operation'
        },
        ["total_tokens"]: {
            id: "slot_7",
            type: "number",
            required: false,
            description: 'Total tokens spent on operation'
        },
        ["model"]: {
            id: "slot_0",
            type: "string",
            required: false,
            description: 'AI model used for operation'
        }
    }
};
